import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import styles from '../heypractice/heypractice.module.css';
import Slide from '../slide';

const Routes = require('../../routes').Routes;

function Heypractice3() {
  const data = useStaticQuery(
    graphql`
      query {
        background: file(relativePath: { eq: "bg/bg_heypractice.png" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        image: file(relativePath: { eq: "img/heypractice-bg.png" }) {
          childImageSharp {
            fluid(maxWidth: 1500, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  const backgroundImageData = data.background.childImageSharp.fluid;
  const imageData = data.image.childImageSharp.fluid;

  return (
    <Slide
      title="Making coaching more efficient with AI-powered feedback"
      text="HeyPractice offers learning tools for salespeople to refine their sales pitches. We created an AI module for voice recognition and text analysis, serving as a virtual coach, to give students feedback and suggestions on enhancing their pitches."
      backgroundImageData={backgroundImageData}
      imageData={imageData}
      imageClassName={styles.image}
      bgColor="#23398D"
      caseLink={Routes.CASE_STUDIES_HEYPRACTICE}
    />
  );
}

export default Heypractice3;
